module.exports = __webpack_public_path__ + "img/3-1.d9a827e8.png";